<template>
  <div v-if="variants && variants.length" class="m-product-variants">
    <div v-if="variantGroups" class="mt-5">
      <label class="m-product-variants__label" :for="getVariantNameByIndex(0)">{{ $t(getVariantNameByIndex(0)) }}</label>
      <base-select
        v-model="selected[getVariantNameByIndex(0)]"
        :field-id="getVariantNameByIndex(0)"
        :options="getVariantValuesByIndex(0)"
        class="mb-3"
        @change="onVariantChanged"
      />
    </div>
    <div v-if="variantGroups && Object.entries(variantGroups).length > 1" class="mt-5">
      <label class="m-product-variants__label" :for="getVariantNameByIndex(1)">{{ $t(getVariantNameByIndex(1)) }}</label>
      <base-select
        v-model="selected[getVariantNameByIndex(1)]"
        :field-id="getVariantNameByIndex(1)"
        :options="getMatchingVariants(getVariantNameByIndex(0), selected[getVariantNameByIndex(0)], getVariantNameByIndex(1))"
        class="mb-3"
        :disabled="Object.entries(selected).length < 1"
        @change="onVariantChanged"
      />
    </div>
  </div>
</template>


<script>
import BaseSelect from '@/components/atoms/BaseSelect'
export default {
  name: 'ProductVariants',
  components: {
    BaseSelect
  },
  props: {
    sku: {
      type: String,
      default: ''
    },
    variants: {
      type: Array,
      default: () => {}
    }
  },
  data () {
    return {
      selected: {},
      variantGroups: {}
    }
  },
  computed: {
    hasDropdownsBeenSelected () {
      return Object.keys(this.selected).length === Object.keys(this.variantGroups).length;
    }
  },
  created () {
    this.variantGroups = this.getVariantGroups();
    let currentVariant = this.variants?.find(variant => variant.sku === this.sku);
    if (currentVariant?.attributes) {
      // We need to copy the variant attributes, otherwise changing the selected object will modifiy the stored variants.
      this.selected = { ...currentVariant.attributes };
    }
  },
  methods: {
    getVariantGroups () {
      let groups = {};
      this.variants?.forEach((variant) => {
        if (variant.attributes) {
          let keys = Object.keys(variant.attributes);
          for (let i=0; i < keys.length; i++) {
            let attr = keys[i];
            let value = variant.attributes[attr];
            // Create new array if this attribute havn't been added yet
            if (!groups[attr]) {
              groups[attr] = [];
            }
            // Only add the value of the attribute once
            let isAlreadyAdded = groups[attr].some(x => x.value === value);
            if (!isAlreadyAdded) {
              groups[attr].push({
                name: value,
                value: value
              })
            }
          }
        }
      });
       // Sort the group arrays alphabetically or nummerically
      Object.keys(groups).forEach(attr => {
        groups[attr].sort((a, b) => {
          return a.value.localeCompare(b.value, 'da', { numeric: true });
        });
      });
      
      return groups;
    },
    getVariantNameByIndex (index) {
      let variant = this.getVariantByIndex(index);
      return variant ? variant[0] : null;
    },
    getVariantValuesByIndex (index) {
      let variant = this.getVariantByIndex(index);
      return variant ? variant[1] : null;
    },
    getVariantByIndex (index) {
      let groups = Object.entries(this.variantGroups);
      return groups ? groups[index] : null;
    },
    getMatchingVariants (previousName, previousValue, currentName) {
      let v = this.variants.filter(v => {
        return Object.entries(v.attributes).some(e => {
          var key = e[0];
          var value = e[1];
          return key === previousName && value === previousValue;
        })
      })
      return v.map(x => {
        return Object.entries(x.attributes).filter(a => a[0] === currentName).map(a => {
          let value = a[1];
          return {
            name: value,
            value: value,
          }
        })
      }).flat().sort((a, b) => a.value.localeCompare(b.value, 'da', { numeric: true }));
    },
    onVariantChanged () {
      if (this.hasDropdownsBeenSelected) {
        // Compare selected attributes with the full list of variants and find the match
        let variantMatch = this.variants.find(variant => {
          return this.areObjectsEqual(variant.attributes, this.selected)
        });
        if (variantMatch) {
          this.$router.push({ path: variantMatch.url })
        }
      }
    },
    areObjectsEqual (obj1, obj2) {
      return JSON.stringify(this.sortObjectByKey(obj1)) === JSON.stringify(this.sortObjectByKey(obj2))
    },
    sortObjectByKey (unordered) {
      return Object.keys(unordered).sort().reduce(
        (obj, key) => {
          obj[key] = unordered[key];
          return obj;
        },
        {}
      );
    },
  }
}
</script>
